export default {
  user: null,
  tokens: null,
  lastUserVerification: null,
}
